import { env } from "./env";

let ga4Initialized = false;
let clarityInitialized = false;

export function initGa4(): void {
  if (ga4Initialized || !env.ga4Id || typeof window === "undefined") return;
  ga4Initialized = true;

  const id = env.ga4Id;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer ?? [];
  const gtag: (...args: unknown[]) => void = (...args) => {
    window.dataLayer?.push(args);
  };
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", id, { send_page_view: true });
}

interface ClarityStub {
  (...args: unknown[]): void;
  q?: unknown[][];
}

export function initClarity(): void {
  if (clarityInitialized || !env.clarityId || typeof window === "undefined") return;
  clarityInitialized = true;

  const id = env.clarityId;
  const w = window as Window & { clarity?: ClarityStub };

  if (!w.clarity) {
    const queue: unknown[][] = [];
    const stub: ClarityStub = (...args: unknown[]) => {
      queue.push(args);
    };
    stub.q = queue;
    w.clarity = stub;
  }

  const tag = document.createElement("script");
  tag.async = true;
  tag.src = `https://www.clarity.ms/tag/${id}`;
  const first = document.getElementsByTagName("script")[0];
  first?.parentNode?.insertBefore(tag, first);
}

export function trackEvent(name: string, params?: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  if (window.gtag) {
    window.gtag("event", name, params ?? {});
  }
  if (window.clarity) {
    try {
      window.clarity("event", name);
    } catch {
      // Clarity may not be loaded yet; ignore.
    }
  }
}
